module.exports = __webpack_public_path__ + "img/profile-avatar.ff0915f3.png";